import { BlastworksClientEvent, ClientController } from "client-controller";
import { FowlPickJokerState } from "state-machine/states/fowl-pick-joker-state";

export class SocialPickJokerState extends FowlPickJokerState {
    /**
     * Allow wilds to trigger the `{slingos: 1}` event after recovering
     */
    public onEnter(): void {
        ClientController.getInstance().raiseEvent(BlastworksClientEvent.RECOVERED);
        super.onEnter();
    }
}
